var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m497 242h-75v-47c0-63.411-51.589-115-115-115h-37v-65c0-8.284-6.716-15-15-15s-15 6.716-15 15v5h-165c-41.355 0-75 33.645-75 75s33.645 75 75 75h165v5c0 8.284 6.716 15 15 15s15-6.716 15-15v-5h37c13.785 0 25 11.215 25 25v47h-75c-8.284 0-15 6.716-15 15v200c0 30.327 24.673 55 55 55h160c30.327 0 55-24.673 55-55v-200c0-8.284-6.716-15-15-15zm-422-102c-24.813 0-45-20.187-45-45s20.187-45 45-45h50.729l45 90zm165 0h-35.729l-45-90h80.729zm67 0h-37v-30h37c46.869 0 85 38.131 85 85v47h-30v-47c0-30.327-24.673-55-55-55zm175 317c0 13.785-11.215 25-25 25h-160c-13.785 0-25-11.215-25-25v-185h210z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377 452h30c8.284 0 15-6.716 15-15s-6.716-15-15-15h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377 332h30c8.284 0 15-6.716 15-15s-6.716-15-15-15h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377 392h50c8.284 0 15-6.716 15-15s-6.716-15-15-15h-50c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167 240c-24.813 0-45 20.187-45 45s20.187 45 45 45 45-20.187 45-45-20.187-45-45-45zm0 60c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437 120h15v15c0 8.284 6.716 15 15 15s15-6.716 15-15v-15h15c8.284 0 15-6.716 15-15s-6.716-15-15-15h-15v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v15h-15c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 30,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 215,
    r: 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiment);
export default __webpack_public_path__ + "static/media/experiment.8fa195b08f8c8a04fa630291a63d95e1.svg";
export { ForwardRef as ReactComponent };